import { Dialog, DialogContent, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Expand } from "lucide-react";
import Reveal from "@/components/Reveal";

const FLYERS = [
  {
    src: "/assets/flyer-packages.jpg",
    title: "Detailing Packages",
    alt: "Luxpress Detailing flyer — detailing packages: Basic Exterior Wash from $99, Basic Interior from $99, Mini Detail from $150, Full Detail from $250",
  },
  {
    src: "/assets/flyer-ceramic.jpg",
    title: "Ceramic Coating",
    alt: "Luxpress Detailing flyer — ceramic coating: ultimate protection, unmatched gloss, tailored protection and custom quotes",
  },
  {
    src: "/assets/flyer-ppf.jpg",
    title: "PPF & Vinyl Wraps",
    alt: "Luxpress Detailing flyer — paint protection film and vinyl wraps: protect, customise, perfect",
  },
];

const FlyerSection = () => (
  <section className="mx-auto max-w-7xl px-5 py-24 sm:px-8 sm:py-32" data-testid="flyers-section">
    <Reveal className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
      <div>
        <p className="kicker">In print</p>
        <h2 className="mt-4 max-w-2xl font-display text-3xl font-bold uppercase tracking-tight sm:text-5xl">
          The flyers.<br />Same standard, on paper.
        </h2>
      </div>
      <p className="max-w-sm text-sm leading-relaxed text-chrome">
        What we hand out in the studio, rendered in the same black and teal. Tap any flyer to read it full size.
      </p>
    </Reveal>
    <div className="mt-14 grid gap-6 sm:grid-cols-3">
      {FLYERS.map((f, i) => (
        <Reveal key={f.src} delay={i * 0.08}>
          <Dialog>
            <DialogTrigger asChild>
              <button
                data-testid={`flyer-${f.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                className="group relative block w-full overflow-hidden border border-teal-line bg-panel text-left transition-colors duration-300 hover:border-mint/50"
                aria-label={`View ${f.title} flyer full size`}
              >
                <img
                  src={f.src}
                  alt={f.alt}
                  loading="lazy"
                  className="aspect-[2/3] w-full object-cover transition-transform duration-500 group-hover:scale-[1.02]"
                />
                <span className="absolute right-4 top-4 flex h-9 w-9 items-center justify-center border border-teal-line bg-black/70 text-mint opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                  <Expand className="h-4 w-4" aria-hidden="true" />
                </span>
                <span className="flex items-center justify-between border-t border-teal-line px-5 py-4">
                  <span className="font-display text-sm font-bold uppercase tracking-tight text-white">{f.title}</span>
                  <span className="spec-label">Flyer</span>
                </span>
              </button>
            </DialogTrigger>
            <DialogContent className="max-h-[92vh] w-[94vw] max-w-md overflow-y-auto border-teal-line bg-black p-2 sm:max-w-lg" data-testid={`flyer-dialog-${f.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
              <DialogTitle className="sr-only">{f.title} flyer</DialogTitle>
              <img src={f.src} alt={f.alt} className="w-full" />
            </DialogContent>
          </Dialog>
        </Reveal>
      ))}
    </div>
  </section>
);

export default FlyerSection;
